import { createContext, useState, useRef, useMemo } from "react";

const WidgetContext = createContext();

const WidgetContextProvider = (props) => {
	const { children } = props;

	const [widget, setWidget] = useState(null);
	const [hostName, setHostName] = useState("");
	const [pathName, setPathName] = useState("/");
	const [assistant, setAssistant] = useState();
	const [agents, setAgents] = useState([]);
	const [conversations, setConversations] = useState([]);
	const [conversationsPagination, setConversationsPagination] = useState(null);
	const [callConversations, setCallConversations] = useState([]);
	const [callConversationsPagination, setCallConversationsPagination] = useState(null);
	const fetchMoreConversationsRef = useRef(null);
	const [tickets, setTickets] = useState([]);
	const [contact, setContact] = useState(null);
	const [isMuted, setIsMuted] = useState(false);
	const [collapsed, setCollapsed] = useState(true);
	const [contactDataCollector, setContactDataCollector] = useState(null);

	const value = useMemo(() => ({
		widget,
		agents,
		conversations,
		conversationsPagination,
		callConversations,
		callConversationsPagination,
		tickets,
		contact,
		isMuted,
		assistant,
		collapsed,
		hostName,
		pathName,
		contactDataCollector,
		setAssistant,
		setWidget,
		setAgents,
		setConversations,
		setConversationsPagination,
		setCallConversations,
		setCallConversationsPagination,
		fetchMoreConversationsRef,
		setTickets,
		setContact,
		setIsMuted,
		setCollapsed,
		setHostName,
		setPathName,
		setContactDataCollector,
	}), [widget, assistant, agents, conversations, conversationsPagination, callConversations, callConversationsPagination, tickets, contact, isMuted, collapsed, hostName, pathName, contactDataCollector]);

	return (
		<WidgetContext.Provider value={value}>
			{children}
		</WidgetContext.Provider>
	);
};

export { WidgetContext, WidgetContextProvider };
